import Joi from "joi";

// Base schema for string validations with custom messages
export const string = Joi.string();
export const email =  string
.email({ tlds: { allow: false } })
.label("Email")
export const password = string.min(6).label("Password") 
export const object = (schema) => Joi.object(schema);
export const ref = (name) => Joi.ref(name) 
export const array = Joi.array();